import { useMutation, useQueryClient } from "@tanstack/react-query";
import { adminService } from "../services/admin.service";

export function useInviteUserToOrg(orgId: string) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ email, roles }: { email: string; roles: string[] }) =>
      adminService.inviteUserToOrg(orgId, email, roles),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["admin-org", orgId] });
    },
  });
}

export function useRemoveUserFromOrg(orgId: string) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (userId: string) => adminService.removeUserFromOrg(orgId, userId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["admin-org", orgId] });
    },
  });
}
